import { render } from "./AffectationPage.vue?vue&type=template&id=96e0da96&ts=true"
import script from "./AffectationPage.vue?vue&type=script&lang=ts"
export * from "./AffectationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__